import {memo, useEffect, useState} from "react";
function IconFunction({name, url}) {
  function isMobile() {
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const minSize = 450;
    return screenWidth <= minSize;
  }
  return (
    <img
      style={{
        width:isMobile()?"15px":"25px",
        height: isMobile()?"15px":"25px",
      }}
      src={url}
      alt={name}
    />
  );
}

export const Icon = memo(IconFunction);
